import store from '../../../store'
import user_profiler from "./user_profiler";
import lang from "../../../sys/lang/lang";

window.U_SM_PRF =  new Vue({
	store,
	el: '#user_small',
	name : "USER_PROFILER",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		user_profiler,
        lang
	}
});
